import { CommonModule } from '@angular/common';
import {
	AfterContentInit,
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	HostListener,
	OnDestroy,
	Renderer2
} from '@angular/core';

import { FooterModule } from '../footer';

@Component({
	selector: 'sh-feature-container',
	imports: [CommonModule, FooterModule],
	templateUrl: './feature-container.component.html',
	styleUrls: ['./feature-container.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeatureContainerComponent implements AfterContentInit, OnDestroy {
	private thisElement?: HTMLElement;
	private appRootObserver?: MutationObserver;

	constructor(
		private elementRef: ElementRef,
		private renderer: Renderer2
	) {}

	//
	// The logic in this component is to resize the height of this feature
	// component to account for browsers on phones (or others?) that include
	// an extra header or footer that affects the usable height. This means
	// we don't have 100vh for the page. The window.innerHeight element
	// provides a height that is usable.
	//

	@HostListener('window:resize')
	public onResize(): void {
		this.setUsableHeight();
	}

	public ngAfterContentInit(): void {
		this.thisElement = this.elementRef.nativeElement.querySelector('.feature-container');

		const appRootElement = document.querySelector('sh-app-root') ?? undefined;
		if (appRootElement) {
			this.appRootObserver = new MutationObserver(() => {
				this.setUsableHeight();
			});
			this.appRootObserver.observe(appRootElement, { subtree: false, childList: true });
		}

		this.setUsableHeight();
	}

	public ngOnDestroy(): void {
		this.appRootObserver?.disconnect();
	}

	/**
	 * Calculate the usable height by subtracting the sh-header-toolbar height and the heights of all app-root
	 * elements tagged with the "data-usable-height-conributor" attribute from the window's inner height
	 */
	private setUsableHeight(): void {
		if (window.innerHeight && this.thisElement) {
			let usableHeight = window.innerHeight;

			const toolBarHeight = document.querySelector('sh-header-toolbar')?.clientHeight ?? 0;
			usableHeight -= toolBarHeight;

			const appRootElement = document.querySelector('sh-app-root');
			if (appRootElement) {
				const usableHeightContributors = appRootElement.querySelectorAll('[data-usable-height-contributor]');
				usableHeightContributors.forEach((element) => {
					usableHeight -= element.clientHeight;
				});
			}

			this.renderer.setStyle(this.thisElement, 'height', `${usableHeight}px`);
		}
	}
}
